import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { Button } from "@/core/components/ui/button";
import { CardContent } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography";

export const AutomaticLoginFailure = () => {
  const navigate = useNavigate();

  return (
    <CardContent>
      <Stack gap="lg" fullWidth>
        <Typography variant="subtitleW1" className="mt-4">
          Password changed
        </Typography>
        <Typography variant="bodyW1" textColor="secondary">
          Your password was changed successfully, but automatic sign-in failed.
          Log in manually with your new password.
        </Typography>
        <Button
          type="button"
          size="lg"
          variant="text"
          fullWidth
          className="[&_svg]:size-5"
          leftIcon={<ArrowLeftIcon />}
          onClick={() => navigate("/login")}
        >
          Log in manually
        </Button>
      </Stack>
    </CardContent>
  );
};
